import { useStore } from 'effector-react'

import {
  $totalCountOfTasksTypes,
  getTasksTypes,
  tasksTypesListMounted,
  $tasksTypes,
} from './model'

export const useTasksTypesList = () => {
  const tasksTypes = useStore($tasksTypes)
  const loading = useStore(getTasksTypes.pending)
  const totalCountOfTasksTypes = useStore($totalCountOfTasksTypes)

  const onChangeTasksTypesList = () => {
    tasksTypesListMounted()
  }

  return {
    tasksTypes,
    totalCountOfTasksTypes,
    loading,
    onChangeTasksTypesList,
  }
}
